(function(angular){
    'use strict';

    angular.module('nucleus.trial-widget', []).component('trialPurchase', {
        templateUrl: 'dashboard/trial-purchase-widget/trial-purchase-widget.2js.html',
        controller: trialPurchaseCtrl,
        controllerAs: 'vm',
        bindings: {
            lang: '<'
        }
    });

    trialPurchaseCtrl.$inject = ['trialService', '$uibModal', '$scope', '$bentoBusyLoader', '$translate'];
    function trialPurchaseCtrl(trialService, $uibModal, $scope, $bentoBusyLoader, $translate) {
        /*jshint validthis:true */
        var vm = this;
        vm.$onInit = onInit;
        vm.extendTrial = extendTrial;
        vm.shareTrial = shareTrial;
        vm.getDropDownGroups = getDropDownGroups;
        function onInit(){
            getRemainingDays().then(function(days){
                vm.daysRemaining = days;
            }).catch(function() {
                vm.daysRemaining = 0;
            });
            vm.lang = getLang(vm.lang);
            getPermissionGroups().then(function(permissionGroups){
                if (permissionGroups.length > 0) {
                    vm.permissionExists = true;
                    vm.selectedGroup = (permissionGroups.length === 1) ? permissionGroups[0].name : null;
                }
                vm.permissionGroups = [];
                for (var i = 0; i < permissionGroups.length; i++) {
                    vm.permissionGroups.push(permissionGroups[i].name);
                }
            });
            getTranslatedStrings();
        }
        function getLang(langCode){
            var defaultLang = 'en';
            return langCode ? langCode.slice(0,2): defaultLang;
        }
        function getRemainingDays() {
            return getTrialExpiration().then(function(expirationDate){
                var today = moment(new Date()); // jshint ignore:line
                var expiration = moment(expirationDate); // jshint ignore:line
                return expiration.diff(today, 'days');
            });
        }
        function getTrialExpiration(){
            return trialService.getTrialExpiration().then(function(resp){
                return resp.data.expireDate;
            });
        }
        function extendTrial(){
            trialService.getTrialExpiration().then(function(resp){
                resp.data.extensionDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS'); // jshint ignore:line
                trialService.extendTrial(resp.data).then(function(extendResp){
                    var today = moment(new Date()); // jshint ignore:line
                    var expiration = moment(extendResp.data.expireDate); // jshint ignore:line
                    vm.daysRemaining = expiration.diff(today, 'days');
                    $translate('onvio.dashboard.extendTrial.extend.success').then(function(value){
                        vm.tialPurchaseAlert = [ {msg: value, type: 'success', closeable: true} ];
                    });
                }).catch(function() {
                    // failed to extend trial
                });
            }).catch(function(){
                // failed to retrieve trial
            });
        }
        function getPermissionGroups() {
            return trialService.getPermissionGroups().then(function(resp){
                return resp.data.dtos;
            }).catch(function() {
                // failed to retrieve permission groups
            });
        }
        function getDropDownGroups(){
            console.log(vm.permissionGroups);
            return vm.permissionGroups;
        }
        function getTranslatedStrings(){
            vm.shareTrialTranslations = [
                $translate.instant('onvio.dashboard.shareTrial.form.error.name.first'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.name.last'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.name.middle'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.name.required'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.email.required'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.incompleteFields'),
                $translate.instant('onvio.dashboard.shareTrial.form.success.trialShared'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.fail.employee'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.fail.permissionGroup'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.fail.registration'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.hhtc.troubleshooting'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.moreInfo'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.fail.unableToShare'),
                $translate.instant('onvio.dashboard.shareTrial.form.error.tryAgain')
            ];
        }
        function shareTrial(){
            var shareModal = $uibModal.open({
                templateUrl: 'dashboard/trial-purchase-widget/share-trial.2js.html',
                controllerAs: 'share',
                backdrop: 'static',
                keyboard: false,
                controller: function() {
                    var share = this;
                    share.selectedGroup = vm.selectedGroup;
                    share.permissionGroups = vm.permissionGroups;
                    share.onStaffNameBlur = function(){
                        if (share.staffNameValue) {
                            share.staffId = share.staffNameValue.slice(0, 20);
                            trialService.verifyUniqueStaffId(share.staffId).then(function(value){
                                if (!value) {
                                    share.staffId = (Math.floor(Math.random() * 9999999999) + 1).toString();
                                }
                            });
                            trialService.parseStaffName(share.staffNameValue).then(function(name){
                                trialService.calculateDisplayAs(name.familyName, name.fullName, name.givenName).then(function(displayAs){
                                    share.displayAs = displayAs;
                                });
                                share.familyName = name.familyName;
                                share.givenName = name.givenName;
                            });
                            var nameArray = share.staffNameValue.split(' ');
                            if(nameArray[0].length > 100) {
                                share.staffNameError = true;
                                share.staffNameErrorMsg = vm.shareTrialTranslations[0];
                            }
                            if(nameArray[nameArray.length - 1].length > 100) {
                                share.staffNameError = true;
                                share.staffNameErrorMsg = vm.shareTrialTranslations[1];
                            }
                            if((nameArray.slice(1, (nameArray.length - 1)).toString().replace(/,/g, ' ')).length > 100) {
                                share.staffNameError = true;
                                share.staffNameErrorMsg = vm.shareTrialTranslations[2];
                            }
                        } else {
                            share.staffNameError = true;
                            share.staffNameErrorMsg = vm.shareTrialTranslations[3];
                        }
                    };
                    share.onFocus = function(elem) {
                        share[elem] = false;
                    };
                    share.onStaffEmailBlur = function(){
                        if (!share.staffEmailValue) {
                            share.staffEmailError = true;
                            share.staffEmailErrorMsg = vm.shareTrialTranslations[4];
                        }
                    };
                    share.onPermissionGroupChange = function(){
                        share.permissionGroupError = false;
                    };
                    share.onPermissionGroupBlur = function(){
                        if (!share.selectedGroup) {
                            share.permissionGroupError = true;
                        }
                    };
                    share.send = function() {
                        share.loading = true;
                        if (share.staffNameValue && share.staffEmailValue && share.selectedGroup) {
                            trialService.onSendClick(share.givenName, share.familyName, share.staffNameValue, share.displayAs, share.staffId, share.staffEmailValue, share.selectedGroup);
                        } else {
                            share.shareTrialAlert = [{
                                type: 'danger',
                                msg: vm.shareTrialTranslations[5],
                                closeable: true
                            }];
                        }
                    };
                    $scope.$on('bmShareTrialEmployeeAdded', function(){
                        share.loading = false;
                        vm.tialPurchaseAlert = [{
                            type: 'success',
                            msg: vm.shareTrialTranslations[6] + ' ' + share.staffNameValue + '.',
                            closeable: true,
                            timeout: 2500
                        }];
                        shareModal.dismiss();
                    });
                    $scope.$on('bmShareTrialErrorAddingStaff', function(event, args){
                        share.loading = false;
                        var hhtcArticleUrl = '/ua/help/ca-' + vm.lang + '/staff/core/common/correct-share-trial-errors.htm';
                        if (!args[0]) {
                            vm.tialPurchaseAlert = [{
                                type: 'danger',
                                msg: vm.shareTrialTranslations[7] + ' <a target="_blank" href=\"' + hhtcArticleUrl + '\">' + vm.shareTrialTranslations[10] + '</a> ' + vm.shareTrialTranslations[11],
                                closeable: true
                            }];
                            shareModal.dismiss();
                        }
                        if (!args[1]) {
                            vm.tialPurchaseAlert = [{
                                type: 'danger',
                                msg: vm.shareTrialTranslations[8] + ' <a target="_blank" href=\"' + hhtcArticleUrl + '\">' + vm.shareTrialTranslations[10] + '</a> ' + vm.shareTrialTranslations[11],
                                closeable: true
                            }];
                            shareModal.dismiss();
                        }
                        if (!args[2]) {
                            vm.tialPurchaseAlert = [{
                                type: 'danger',
                                msg: vm.shareTrialTranslations[9] + ' <a target="_blank" href=\"' + hhtcArticleUrl + '\">' + vm.shareTrialTranslations[10] + '</a> ' + vm.shareTrialTranslations[11],
                                closeable: true
                            }];
                            shareModal.dismiss();
                        }
                    });
                    $scope.$on('bmShareTrialErrorAddingContact', function(event, args){
                        share.loading = false;
                        switch (args) {
                            case 'duplicateEmail':
                                share.staffEmailError = true;
                                share.duplicateEmail = true;
                                break;
                            case 'unableToAddStaff':
                                vm.tialPurchaseAlert = [{
                                    type: 'danger',
                                    msg: vm.shareTrialTranslations[12] + ' ' + share.staffNameValue + '. ' + vm.shareTrialTranslations[13],
                                    closeable: true
                                }];
                                shareModal.dismiss();
                                break;
                        }
                    });
                    share.cancel = function() {
                        shareModal.dismiss();
                    };
                }
            });
        }
    }
})(window.angular);
